import { CopyOutlined, EyeOutlined } from "@ant-design/icons";
import { useGetOfferQuery } from "api/TenantSlug/Offer/hooks";
import { OfferApiDocumentationDrawer } from "components/Drawers/OfferApiDocumentationDrawer/OfferApiDocumentationDrawer";
import { OfferApiDetailForm } from "components/Forms/OfferApiDetailForm/OfferApiDetailForm";
import { OfferDetail } from "components/other/OfferDetail/OfferDetail";
import { ActionTitle } from "components/UI/ActionTitle/ActionTitle";
import { QueryState } from "components/UI/QueryState/QueryState";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { DrawerId } from "types/models";

export const OfferApiDetail = ({ offerId }: { offerId: string }) => {
    const { data, isLoading, isError } = useGetOfferQuery(offerId, {
        filter: { include: "forms,formStructures,affiliates" },
    });
    const offer = data?.offer;
    const { t } = usePaldockTranslation("components.offer-api-detail");
    const { t: tC } = usePaldockTranslation("common");
    const { t: tG } = usePaldockTranslation("general");
    const drawerUtils = useDrawer();

    const [currentEndpoint, setCurrentEndpoint] = useState<string>("");

    useEffect(() => {
        setCurrentEndpoint("");
    }, [offerId]);

    const copyEndpointToClipboard = () => {
        if (currentEndpoint) {
            navigator.clipboard
                .writeText(currentEndpoint)
                .then(() => toast.info(t("messages.endpoint_copied")))
                .catch(() => toast.error(t("messages.endpoint_copy_failed")));
        }
    };

    const openDocumentationDrawer = () => {
        const firstStructureId = offer?.form_structures?.[0]?.id;
        drawerUtils.show(DrawerId.OfferApiDocumentation, {
            doc_s: firstStructureId,
            doc_o: offerId,
        });
    };

    if (!offer) {
        return <QueryState isLoading={isLoading} isError={isError || !isLoading} errorKey="errors.loading_offer" />;
    }

    return (
        <>
            <OfferDetail offer={offer}>
                <SectionContentWrapper>
                    <ActionTitle
                        title={{
                            text: t("title"),
                            level: 3,
                        }}
                        buttons={[
                            {
                                text: tG("documentation"),
                                icon: <EyeOutlined />,
                                type: "default",
                                callback: openDocumentationDrawer,
                            },
                            {
                                text: tC("copy"),
                                icon: <CopyOutlined />,
                                callback: copyEndpointToClipboard,
                            },
                        ]}
                    />
                    <OfferApiDetailForm
                        key={offerId}
                        offerId={offerId}
                        offer={offer}
                        showUserSelect={true}
                        onEndpointChange={setCurrentEndpoint}
                    />
                </SectionContentWrapper>
            </OfferDetail>
            <OfferApiDocumentationDrawer />
        </>
    );
};
